<section class="vo-card" aria-labelledby="step35-title">
  <header class="vo-card__head">
    <h2 class="vo-card__title" id="step35-title">Reinigungsumfang</h2>
    <p class="vo-card__sub">Was soll gereinigt werden?</p>
  </header>

  <form class="vo-grid" [formGroup]="draftInquiryForm" novalidate>
    <div class="vo-field vo-field--full">
      <span class="vo-label" id="step35-coverings">Welche Bodenbeläge möchten Sie reinigen lassen?</span>
      <div class="vo-chips" role="group" aria-labelledby="step35-coverings">
        <button *ngFor="let option of floorCoveringsOptions" type="button" class="vo-chip"
                [class.is-selected]="isFloorCoveringsActive(option.value)"
                [attr.aria-pressed]="isFloorCoveringsActive(option.value)"
                (click)="toggleFloorCoverings(option.value)">
          <app-icon [name]="option.lucideIcon"/>
          {{ option.label }}
        </button>
      </div>
    </div>

    <h3 class="vo-section-head">Badezimmer-Details</h3>

    <div class="vo-field">
      <label class="vo-label" for="nur_wc">Nur WC</label>
      <select id="nur_wc" class="vo-select" formControlName="nur_wc">
        <option *ngFor="let option of bathroomOptions" [value]="option.value">{{ option.label }}</option>
      </select>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="dusche_ws">Dusche und WC</label>
      <select id="dusche_ws" class="vo-select" formControlName="dusche_ws">
        <option *ngFor="let option of bathroomOptions" [value]="option.value">{{ option.label }}</option>
      </select>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="bad_wc">Bad und WC</label>
      <select id="bad_wc" class="vo-select" formControlName="bad_wc">
        <option *ngFor="let option of bathroomOptions" [value]="option.value">{{ option.label }}</option>
      </select>
    </div>

    <div class="vo-field">
      <label class="vo-label" for="dusche_bad_wc">Dusche, Bad und WC</label>
      <select id="dusche_bad_wc" class="vo-select" formControlName="dusche_bad_wc">
        <option *ngFor="let option of bathroomOptions" [value]="option.value">{{ option.label }}</option>
      </select>
    </div>

    <div class="vo-field vo-field--full">
      <span class="vo-label" id="step35-blinds">Welche Art Storen möchten Sie reinigen lassen?</span>
      <div class="vo-chips" role="group" aria-labelledby="step35-blinds">
        <button *ngFor="let option of blindsOptions" type="button" class="vo-chip"
                [class.is-selected]="isBlindsActive(option.value)"
                [attr.aria-pressed]="isBlindsActive(option.value)"
                (click)="selectBlinds(option.value)">
          <app-icon [name]="option.lucideIcon"/>
          {{ option.label }}
        </button>
      </div>
    </div>

    <div class="vo-field vo-field--full">
      <span class="vo-label" id="step35-rooms">
        Welche zusätzlichen Räume möchten Sie reinigen lassen? <span class="vo-label__optional">(optional)</span>
      </span>
      <div class="vo-chips" role="group" aria-labelledby="step35-rooms">
        <button *ngFor="let option of additionalRoomsOptions" type="button" class="vo-chip"
                [class.is-selected]="isAdditionalRoomsActive(option.value)"
                [attr.aria-pressed]="isAdditionalRoomsActive(option.value)"
                (click)="toggleAdditionalRooms(option.value)">
          <app-icon [name]="option.lucideIcon"/>
          {{ option.label }}
        </button>
      </div>
    </div>

    <div class="vo-field vo-field--full" *ngIf="hasComment">
      <label class="vo-label" for="comment">
        Besondere Gegenstände / Bemerkungen <span class="vo-label__optional">(optional)</span>
      </label>
      <textarea id="comment" class="vo-textarea" rows="3" formControlName="comment"
                placeholder="z.B. Backofen, Balkonverglasung, besondere Anforderungen …"></textarea>
    </div>
  </form>
</section>

<app-inquiry-step-nav (back)="goBack()" (next)="onSubmit()"/>
